// Add your custom JS here.
(function ($) {
    // Fade in effects
    AOS.init();

    // Smooth anchor scrolling
    var scroll = new SmoothScroll('a[href*="#"]', {
        speed: 300,
    });


    $(".menu a").each(function() {
        var $menutext = $(this).text().toLowerCase();
        $(this).addClass($menutext);
    });

    // page sub menus
    if($('ul.menu').length){
        // $('ul.menu li:first-child a').addClass('active');

        $(window).on('scroll', function() {
            $(".anchor").each(function() {
                if ($(window).scrollTop() >= $(this).offset().top - 50) {
                    var currentItem = $(this).attr('id');
                    $('ul.menu a').removeClass('active');
                    $('ul.menu .' + currentItem + '').addClass('active');
                }
            });
        });
    }



    var swiper = new Swiper(".building-swiper", {
        slidesPerView: 1,
        center: true,
        loop: false,
        speed: 500,
        effect: "fade",
        pagination: {
            el: ".swiper-pagination",
            type: "bullets",
            clickable: true,
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
            clickable: true,
        },
    });

    var swiper = new Swiper(".services-swiper", {
        slidesPerView: 1,
        autoHeight: true,
        spaceBetween: 20,
        loop: false,
        pagination: {
            el: ".services-pagination",
            type: "bullets",
            clickable: true,
        },
        navigation: {
            nextEl: ".services-button-next",
            prevEl: ".services-button-prev",
            clickable: true,
        },
        breakpoints: {
            768: {
                spaceBetween: 500,
                slidesPerView: "2",
            },
            1024: {
                spaceBetween: 500,
                slidesPerView: "3",
            },
        },
    });

    //Block wrapper

    // $("._blocks .block:first-child").wrap("<div class='first-block'></div>");
    // $("._blocks .block:nth-child(2)").wrap("<div class='second-block'></div>");
    // $("._blocks .block:nth-child(3)").appendTo(".second-block");
    // $("._blocks .block:nth-child(3)").wrap("<div class='third-block'></div>");
    // $("._blocks .block:nth-child(4)").appendTo(".third-block");

    $(".block-1").wrapAll("<div class='first-block'></div>");
    $(".block-2, .block-4").wrapAll("<div class='second-block'></div>");
    $(".block-3, .block-5").wrapAll("<div class='third-block'></div>");

    //Map

    $(".tabs-inner .title:first-child").addClass("active");
    $(".tabs-inner .title").on("click", function () {
        $(".tabs-inner .title").removeClass("active");
        $(this).addClass("active");
    });

    $(".tabs-inner .title:first-child").on("click", function () {
        $(".maps").removeClass("active");
    });
    $(".tabs-inner .title:nth-child(2)").on("click", function () {
        $(".maps").addClass("active");
    });

    //Header scroll

    // check if page is scrolled from the top for header
    $(document).scroll(function () {
        if ($(this).scrollTop() > 50) {
            $("#wrapper-navbar").addClass("off-top");
        }
        if ($(this).scrollTop() < 50) {
            $("#wrapper-navbar").removeClass("off-top");
        }
    });

    // show header based on scroll directions
    var lastScrollTop = 0;
    $(window).scroll(function (event) {
        var st = $(this).scrollTop();
        if (st > lastScrollTop) {
            $("#wrapper-navbar").addClass("hide");
        } else {
            $("#wrapper-navbar").removeClass("hide");
        }
        lastScrollTop = st;
    });

    //video

    const iframe = document.querySelector('#vimeoplayer');
    const player = new Vimeo.Player(iframe);

    $(".play").on("click", function () {
        $(".video").addClass("active");
        player.play();
    });

    $(".video").on("click", function () {
        $(".video").removeClass("active");
        $("iframe").attr("src", $("iframe").attr("src"));
    });
})(jQuery);
